<script>
import ListView from "@/arch/components/data-table/ListView.vue";
import { VUE_APP_DECIMALS } from "@/config";

export default {
  extends: ListView,
  name: "ListBillingItemsComponent",
  props: {
    details: {
      type: [Object, Array],
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      namePage: this.$i18n.t("listItems"),
      path: "facturacion",
      headerContent: () => import("./ListBillingItemsHeaderComponent.vue"),
      hideDefaultActions: true,
      addNew: false,
      configColumns: false,
      dataProperties: {
        path: "facturacion",
        namePage: this.$i18n.t("billingItems"),
      },
      headers: [
        {
          text: this.$i18n.t("itemCode"),
          align: "start",
          sortable: true,
          value: "ITEM",
        },
        {
          text: this.$i18n.t("description"),
          align: "start",
          sortable: true,
          value: "DESCRIPTION",
        },
        {
          text: this.$i18n.t("line"),
          align: "start",
          sortable: true,
          value: "DESC_LINE",
        },
        {
          text: this.$i18n.t("amount"),
          align: "start",
          sortable: true,
          value: "QTY",
        },
        {
          text: this.$i18n.t("subtotal"),
          align: "start",
          sortable: true,
          value: "PRICE",
          infoMessage: this.$i18n.t("valueWithoutTaxes"),
          component: "DataTableCurrencyColumn",
          options: {
            prefix: "$USD",
            dynamicPrefix: "CURRENCY",
            decimals: VUE_APP_DECIMALS,
          },
        },
        {
          text: this.$i18n.t("price"),
          align: "start",
          sortable: true,
          value: "TOTAL",
          component: "DataTableCurrencyColumn",
          options: {
            prefix: "$USD",
            dynamicPrefix: "CURRENCY",
            decimals: VUE_APP_DECIMALS,
          },
        },
      ],
    };
  },
  methods: {
    async getItemsList() {
      return true;
    },
  },
  computed: {
    getListFilter() {
      return this.details;
    },
  },
};
</script>